export default {
  'deliveryPoint.additional.add': '+ Add Additional Delivery Point',
  'deliveryPoint.delete': 'Delete Delivery Point',
  'deliveryPoint.required': 'Required'
};
